import { render, staticRenderFns } from "./CookieWarning.vue?vue&type=template&id=4075b4e3&scoped=true"
import script from "./CookieWarning.vue?vue&type=script&lang=js"
export * from "./CookieWarning.vue?vue&type=script&lang=js"
import style0 from "./CookieWarning.vue?vue&type=style&index=0&id=4075b4e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075b4e3",
  null
  
)

export default component.exports